import React, { useState } from "react";
import styled from 'styled-components';
import { breakpoints, Section, SectionBody, Column, H2 } from '../layout';

const SectionWrapper = styled.div`
    
`

const FormColumn = styled(Column)`
    display: flex;
    justify-content:center;
    padding: 0;
    margin: 1.5rem 0 0 0;

    ${breakpoints.large} {
        margin: 0;
    }
`

const Form = styled.form`
    width: 100%;

    ${breakpoints.large} {
        width: 80%;
    }
`

const InputWrapper = styled.div`
    margin: 0 0 1.5rem;
`

const Label = styled.label`
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 500;
    font-size: 1.5rem;
    margin: 0 0 1rem 0;
    color: #2A8236;
    display: block;
`

const Input = styled.input`
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 500;
    font-size: 1.25rem;
    width: 100%;
    display: block;
    padding: 0.5rem;
    border: 1px solid #5F635F;
    border-radius: 4px;

    :disabled {
    }
`

const Textarea = styled.textarea`
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 500;
    font-size: 1.25rem;
    width: 100%;
    display: block;
    padding: 0.5rem;
    border: 1px solid #5F635F;
    border-radius: 4px;
`

const Button = styled.button`
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 500;
    font-size: 1.5rem;
    background-color: #2A8236;
    color: white;
    padding: 0.5rem 4rem;
    border: 0;
    border-radius: 4px;
    width: 100%;
`

const SentMessage = styled.p`
    text-align: center;
    padding-top: 1rem;
`;

const WarningMessage = styled.p`
    padding: 1rem;
    background: #fecaca;
    border: 1px solid #ef4444;
    border-radius: 4px;
    font-size: 1rem;

    span {
        font-weight: bold;
    }
`;

const FORM_ENDPOINT = 'https://getform.io/f/147b985c-d0a3-4d9e-9eea-a81418cf2e6c'

const STATUS = {
    sending: 'SENDING',
    sent: 'SENT'
}

const Contact = () => {
    const [status, setStatus] = useState()
    const [isDisabled, setIsDisabled] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        if(!isDisabled) {
            const formData = new FormData();
            formData.append(
                'email',
                document.querySelector('input[name="email"').value
            )
            formData.append(
                'phone',
                document.querySelector('input[name="phone"').value
            )
            formData.append(
                'message',
                document.querySelector('textarea[name="message"').value
            )

            if (status !== STATUS.sending) {
                setStatus(STATUS.sending)

                fetch(FORM_ENDPOINT, {
                    method: "POST",
                    body: formData
                }).then((response) => {
                    setStatus(STATUS.sent)
                })
            }
        }
    }

    return (
        <SectionWrapper>
            <Section id="contact">
                <H2>Contact</H2>
                <SectionBody>
                    <Column>
                        <p>Please get in touch using the form. You will receive a response as soon as possible.</p>
                    </Column>
                    <FormColumn>
                        <Form onSubmit={handleSubmit} action={FORM_ENDPOINT} method="POST" target="_blank">
                            <InputWrapper>
                                <Label>Email</Label>
                                <Input name="email" type="email" required disabled={isDisabled} />
                            </InputWrapper>
                            <InputWrapper>
                                <Label>Phone</Label>
                                <Input name="phone" type="text" disabled={isDisabled} />
                            </InputWrapper>
                            <InputWrapper>
                                <Label>Message</Label>
                                <Textarea name="message" required disabled={isDisabled} />
                            </InputWrapper>
                            { isDisabled && (<WarningMessage><span>Please note:</span> this contact form is suspended between 24 November 2025 – 5 January 2026. Polis Legal is not accepting new enquiries over this period.</WarningMessage>) }
                            <Button type="submit" disabled={isDisabled}>{status === STATUS.sending ? 'Sending...' : 'Send'}</Button>
                            <SentMessage>{status === STATUS.sent ? 'Message Sent!' : ''}</SentMessage>
                        </Form>
                    </FormColumn>
                </SectionBody>
            </Section>
        </SectionWrapper>
    )
}

export default Contact;
